import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const [ChipContextProvider, useChipContext] = buildGlobalReferenceContext("Chip");

export { ChipContextProvider, useChipContext };
//# sourceMappingURL=context.mjs.map
